export default "__VITE_ASSET__19f2e6a0__"